/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, Form as FormCore, type FormProps as FormCoreProps, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { breakpoints } from '../../constants.stylex';

interface InlineTableFormProps extends Omit<FormCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const InlineTableFormContext = createContext<ContextValue<InlineTableFormProps, HTMLFormElement>>({});

const InlineTableForm = forwardRef((props: InlineTableFormProps, ref: ForwardedRef<HTMLFormElement>) => {
  [props, ref] = useContextProps(props, ref, InlineTableFormContext);

  const { style, children, ...coreProps } = props;

  return (
    <FormCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </FormCore>
  );
});

const styles = stylex.create({
  base: {
    // Currently, there is no other way to style even rows. RAC does not disclose the row index
    // eslint-disable-next-line @stylexjs/valid-styles
    ':not(#__unused__) > :nth-child(odd):not([data-editing])': {
      backgroundColor: $.surfaceBGSecondary,
    },
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    width: '100%',
    minWidth: {
      default: 360,
      [breakpoints.small]: null
    },
  },
});

export { InlineTableForm, InlineTableFormContext, type InlineTableFormProps };
